import { Link } from "./link.model"

export class BillingConfig {
	merchantId: string
	uuid: string
	advancePaymentPercentage: number
	iban: string
	bic: string
	_links: {
		self: Link,
		billingConfig: Link,
		findByMerchantId: Link
	}

	constructor() {
		this.merchantId = null;
		this.uuid = null;
		this.advancePaymentPercentage = null;
		this._links = null;
		this.iban = null;
		this.bic = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/billing-config.model.ts